var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Lock from "../../../assets/feather/lock.svg";
import { addToBetSlip } from "../../../services/betslip.services";
import _ from "lodash";
import { marketNameTransform } from "../../../services/sportsbook.services";
import { customFlexMarkets, handicappedMarkets, hideSpecialOddsValueOutcomeName, listOfOddsContainingLongNames, listOfOddsContainingPlayerNames, listOfOddsNeedsAccordion } from "../../../definitions/constants/market-categories.constant";
export function Odd(props) {
    // fixme: re-render edilmesede bu kısım sürekli çalıştırılıyor gibi kontrol et
    var market = props.market;
    var specialClass = '';
    var _a = React.useState(false), isCollapsed = _a[0], setIsCollapsed = _a[1];
    React.useEffect(function () {
        if (market && (market === null || market === void 0 ? void 0 : market.marketType) && (market === null || market === void 0 ? void 0 : market.marketSubType)) {
            setIsCollapsed(listOfOddsNeedsAccordion.includes("".concat(market.marketType, "-").concat(market.marketSubType)));
        }
    }, [market === null || market === void 0 ? void 0 : market.marketType, market === null || market === void 0 ? void 0 : market.marketSubType]);
    if (market && market.channelWeb == 1) {
        var event_1 = props.event;
        var marketOutcome = market.marketOutcome;
        if (event_1.eventType === '2') {
            marketOutcome = _.orderBy(market.marketOutcome.filter(function (el) { return el.fixedOddsWeb > 1; }), function (o) {
                return new Number(o.fixedOddsWeb);
            });
        }
        var col_1 = Math.ceil(12 / marketOutcome.length);
        if (col_1 === 2) {
            col_1 = 4;
        }
        else if (col_1 === 3) {
            col_1 = 6;
        }
        else if (col_1 === 1) {
            col_1 = 4;
        }
        if (event_1.eventType === '2' || event_1.sportSlug === 'motor-sporlar') {
            col_1 = 6;
        }
        if (listOfOddsContainingPlayerNames.includes("".concat(market.marketType, "-").concat(market.marketSubType))) {
            col_1 = 6;
        }
        if (listOfOddsContainingLongNames.includes("".concat(market.marketType, "-").concat(market.marketSubType))) {
            col_1 = 12;
            specialClass = 'px-1 mb-1';
        }
        if (customFlexMarkets.includes("".concat(market.marketType, "-").concat(market.marketSubType))) {
            col_1 = 6;
        }
        return (_jsxs(React.Fragment, { children: [marketOutcome.map(function (outcome, key) {
                    var _a;
                    if (isCollapsed && key > 5) {
                        return;
                    }
                    return (_jsxs("div", __assign({ className: "col-".concat(col_1, " ").concat(specialClass, " ") +
                            (market.specialOddsValue && market.specialOddsValue !== ''
                                ? ' specialOddsValue '
                                : '') }, { children: [!props.showOutcomeName ? (_jsxs("div", __assign({ className: 'outcome-name text-center ' }, { children: [_jsx("span", __assign({ className: "label" }, { children: hideSpecialOddsValueOutcomeName.includes(market.marketType + '-' + market.marketSubType)
                                            ? ''
                                            : outcome.outcomeName }), void 0), handicappedMarkets.includes(market.marketType + '-' + market.marketSubType) ||
                                        hideSpecialOddsValueOutcomeName.includes(market.marketType + '-' + market.marketSubType) ||
                                        market.marketName.includes('Maçın Geri Kalanını Kim Kazanır') ||
                                        market.marketName.includes('Sıradaki Golü Kim Atar')
                                        ? marketNameTransform(outcome.outcomeName, market.specialOddsValue, market)
                                        : " ".concat((market.specialOddsValue === '.5'
                                            ? '0.5'
                                            : outcome.outcomeName.includes(" ".concat(market.specialOddsValue
                                                ? (_a = market.specialOddsValue) === null || _a === void 0 ? void 0 : _a.toString().replace('.', ',')
                                                : ''))
                                                ? ''
                                                : market.specialOddsValue) || '')] }), void 0)) : null, _jsxs("button", __assign({ className: "btn btn-odds ".concat(outcome.customOdds && 'custom-odds', " ").concat(outcome.isUpdated, " added-").concat(outcome.isSelected, " ") +
                                    (Number(event_1.bettingPhase) < 0 ||
                                        market.marketStatus < 1 ||
                                        market.marketStatus > 1
                                        ? 'locked'
                                        : ''), onClick: function () {
                                    addToBetSlip(event_1, market, outcome);
                                    // console.log(market.marketType + '-' + market.marketSubType);
                                } }, { children: [props.showOutcomeName ? (_jsx("div", __assign({ className: "outcome-name" }, { children: marketNameTransform(outcome.outcomeName, market.specialOddsValue, market, outcome) }), void 0)) : (_jsx(React.Fragment, {}, void 0)), _jsx("div", __assign({ className: 'ratio ' + (props.showOutcomeName ? 'text-right' : '') }, { children: market.marketStatus < 0 ? (_jsx("img", { src: Lock, className: "invert-color" }, void 0)) : (_jsx(React.Fragment, { children: Number(outcome.fixedOddsWeb) > 1 &&
                                                market.marketStatus !== 0 &&
                                                market.marketStatus < 2 ? (_jsxs(React.Fragment, { children: [outcome.customOdds && (_jsx("span", { children: Number(outcome.fixedOddsWeb).toFixed(2) }, void 0)), Number(outcome.fixedOdds).toFixed(2)] }, void 0)) : (_jsx("div", { children: " - " }, void 0)) }, void 0)) }), void 0)] }), void 0)] }), 'odds_' + event_1.eventId + market.marketId + '__' + key));
                }), listOfOddsNeedsAccordion.includes("".concat(market.marketType, "-").concat(market.marketSubType)) && (_jsx("div", __assign({ className: "col-12 d-flex justify-content-center", onClick: function () {
                        setIsCollapsed(function (prev) { return !prev; });
                    } }, { children: _jsx("button", __assign({ className: "btn btn-odds mb-1" }, { children: isCollapsed ? 'Daha Fazla Göster' : 'Gizle' }), void 0) }), void 0))] }, void 0));
    }
    else {
        return _jsx(React.Fragment, {}, void 0);
    }
}
